import React, { useState, useEffect, useRef } from 'react'; // ✅ useRef ইম্পোর্ট করা হয়েছে
import io from 'socket.io-client';

const SOCKET_SERVER_URL = 'https://api.gp-pay.net';

const reloadPage = () => {
    window.location.reload(); 
};

const socket = io(SOCKET_SERVER_URL, {
    autoConnect: false, 
});

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [masterKey, setMasterKey] = useState(''); 
    const [message, setMessage] = useState('');
    const [whatsappLink, setWhatsappLink] = useState('#');
    const [isLoading, setIsLoading] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    
    const [showMasterKeyForm, setShowMasterKeyForm] = useState(false);
    
    // ✅ useRef এখন কোনো এরর দেবে না
    const masterKeyRef = useRef('');

    useEffect(() => {
        setWhatsappLink('https://wa.me/88017xxxxxxxx'); 
    }, []);

    useEffect(() => {
        const handleConnect = () => setIsConnected(true);
        const handleDisconnect = () => {
            setIsConnected(false);
            setIsLoading(false);
        };

        const handleLoginResponse = (data) => {
            setIsLoading(false);
            if (data.status === 'success') {
                // 🔑 socket auth token সেভ — পরবর্তী socket (re)connect এ handshake.auth.token হিসেবে যাবে
                if (data.token) localStorage.setItem('token', data.token);
                if (data.isMaster === false || data.isMaster === "false") {
                    setShowMasterKeyForm(true);
                    setMessage('🔑 Please enter Master Key to continue.');
                    localStorage.setItem('adminId', data.adminId);
                    localStorage.setItem('adminId2', data.adminId);
                } else {
                    localStorage.setItem('isMaster', 'true');
                    setMessage('✅ Login successful! Redirecting...');
                    setTimeout(reloadPage, 1000); 
                    localStorage.setItem('adminId', data.adminId);
                    localStorage.setItem('adminUsername', data.username);
                    localStorage.setItem('adminId2', data.adminId);
                }
            } else {
                setMessage(`⚠️ ${data.message || 'Login failed!'}`);
            }
        };

        const handleMasterKeyResponse = (data) => {
            setIsLoading(false);

            if (data.status === 'success') {
                localStorage.setItem('isMaster', 'false');
                localStorage.setItem('adminId', data.admin_id); 
                localStorage.setItem('adminUsername', data.username);
                localStorage.setItem('permissions', JSON.stringify(data.permissions));
                localStorage.setItem('allowedUsers', JSON.stringify(data.allowedUsers || []));
                
                // ✅ Master Key লোকাল স্টোরেজে সেভ
                localStorage.setItem('masterKey', masterKeyRef.current);

                setMessage('✅ Master Key Verified! Redirecting...');
                
                // ✅ পেজ রিলোড এর কমেন্ট (//) তুলে দেওয়া হয়েছে, এখন রিডাইরেক্ট হবে
                setTimeout(reloadPage, 1000);
            } else {
                setMessage(`⚠️ ${data.message || 'Invalid Master Key!'}`);
            }
        };

        socket.on('connect', handleConnect);
        socket.on('disconnect', handleDisconnect);
        socket.on('login-response', handleLoginResponse);
        socket.on('master-key-verified', handleMasterKeyResponse);

        if (!socket.connected) socket.connect(); 

        return () => {
            socket.off('connect', handleConnect);
            socket.off('disconnect', handleDisconnect);
            socket.off('login-response', handleLoginResponse);
            socket.off('master-key-verified', handleMasterKeyResponse);
            socket.disconnect(); 
        };
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        if (!isConnected) return setMessage('❌ Server disconnected');
        setIsLoading(true);
        socket.emit('admin-login', { username, password });
    };

    const handleVerifyMasterKey = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        // সাবমিট করার সময় Ref-এ বর্তমান Master Key সেভ করে রাখা হচ্ছে
        masterKeyRef.current = masterKey;

        socket.emit('verify-master-key', { key: masterKey });
    };

    return (
        <div className="login-wrapper">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                body {
                    margin: 0;
                    padding: 0;
                    font-family: 'Inter', sans-serif;
                    background-color: #0f172a; 
                }

                .login-wrapper {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                }

                .login-card {
                    background: #ffffff;
                    width: 100%;
                    max-width: 380px; 
                    padding: 40px 30px;
                    border-radius: 16px;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
                    border: 1px solid #e2e8f0;
                    text-align: center;
                }

                .brand-logo {
                    width: 70px;
                    height: 70px;
                    object-fit: contain;
                    margin-bottom: 15px;
                    border-radius: 50%;
                    padding: 5px;
                    background: #fff;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.08);
                }

                h3 {
                    color: #334155;
                    font-weight: 700;
                    font-size: 22px;
                    margin-bottom: 8px;
                    margin-top: 0;
                }
                
                p.subtitle {
                    color: #64748b;
                    font-size: 13px;
                    margin-bottom: 30px;
                }

                .form-group {
                    margin-bottom: 20px;
                    text-align: left;
                }

                .form-label {
                    display: block;
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    margin-bottom: 6px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .custom-input {
                    width: 100%;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    padding: 12px 15px;
                    border-radius: 8px;
                    font-size: 14px;
                    color: #334155;
                    outline: none;
                    transition: all 0.2s;
                    box-sizing: border-box;
                }

                .custom-input:focus {
                    border-color: #0284c7;
                    background: #fff;
                    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.1);
                }

                .btn-submit {
                    width: 100%;
                    background: #0284c7;
                    color: white;
                    border: none;
                    padding: 14px;
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: 0.3s;
                    margin-top: 10px;
                }

                .btn-submit:hover {
                    background: #0369a1;
                    transform: translateY(-1px);
                }

                .btn-submit:disabled {
                    background: #94a3b8;
                    cursor: not-allowed;
                    transform: none;
                }

                .alert {
                    padding: 12px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 500;
                    margin-bottom: 20px;
                    text-align: left;
                }
                .alert-success { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }
                .alert-danger { background: #fee2e2; color: #dc2626; border: 1px solid #fecaca; }

                .footer-text {
                    margin-top: 30px;
                    font-size: 12px;
                    color: #94a3b8;
                }

                .whatsapp-float {
                    position: fixed;
                    bottom: 20px;
                    right: 20px;
                    width: 50px;
                    height: 50px;
                    background: #25D366;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
                    transition: transform 0.3s;
                    z-index: 999;
                }
                .whatsapp-float:hover { transform: scale(1.1); }
                .whatsapp-icon { width: 30px; height: 30px; }
            `}</style>
            
            <div className="login-card">
                <img src="logo.png" alt="Dabit Pay" className="brand-logo" />
                <h3>Dabit Pay Gateway</h3>
                <p className="subtitle">Sign in to your dashboard</p>

                {message && (
                    <div className={`alert ${message.includes('✅') ? 'alert-success' : 'alert-danger'}`}>
                        {message}
                    </div>
                )}

                {!showMasterKeyForm ? (
                    <form onSubmit={handleLogin}>
                        <div className="form-group">
                            <label className="form-label">Username</label>
                            <input 
                                type="text" 
                                className="custom-input" 
                                placeholder="Enter your username" 
                                value={username} 
                                onChange={(e) => setUsername(e.target.value)} 
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <input 
                                type="password" 
                                className="custom-input" 
                                placeholder="Enter your password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                required
                            />
                        </div>
                        <button type="submit" className="btn-submit" disabled={isLoading || !isConnected}>
                            {isLoading ? 'Processing...' : 'Sign In'}
                        </button>
                    </form>
                ) : (
                    <form onSubmit={handleVerifyMasterKey}>
                        <div className="form-group">
                            <label className="form-label">Security Verification</label>
                            <input 
                                type="text" 
                                className="custom-input" 
                                placeholder="Enter 6-digit Master Key"
                                value={masterKey} 
                                onChange={(e) => setMasterKey(e.target.value)} 
                                style={{textAlign: 'center', letterSpacing: '5px', fontSize: '18px'}}
                                required
                            />
                        </div>
                        <button type="submit" className="btn-submit" disabled={isLoading}>
                            {isLoading ? 'Verifying...' : 'Verify Access'}
                        </button>
                    </form>
                )}

                <div className="footer-text">
                    © {new Date().getFullYear()} Dabit Pay Gateway
                </div>
            </div>

            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-float">
                <img src="whatsapp.png" alt="Help" className="whatsapp-icon" />
            </a>
        </div>
    );
}

export default Login;